import { render } from "./Ordina.vue?vue&type=template&id=46174ff0&scoped=true"
import script from "./Ordina.vue?vue&type=script&lang=js"
export * from "./Ordina.vue?vue&type=script&lang=js"

import "./Ordina.vue?vue&type=style&index=0&id=46174ff0&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46174ff0"]])

export default __exports__